import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import es from 'vuetify/lib/locale/es'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify, {
  theme: {
    blue: colors.blue.darken4,
    indigo: colors.indigo.indigo,
    deepPurple: colors.deepPurple.deepPurple,
    cyan: colors.cyan.cyan,
    green: colors.green.green,
    orange: colors.orange.orange,
    grey: colors.grey.darken1,
    lighten1: colors.green.lighten1
  }
})

const opts = {
  icons: {
    iconfont: 'mdi'
  },
  lang: {
    locales: { es },
    current: 'es'
  }
}

export default new Vuetify(opts)



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js